BuyButton = window.BuyButton ?= {}

{getBuyUrlWithShippingOptionData} = require '../../../../goods_local_supply_v2/common/helpers'
Affirm = require '../../../../affirm_info/frontend/affirm'
FetchHandler = require '../../../../deal/frontend/FetchHandler'
addGiftingToUrl = require('../../../common/add_gifting_to_url')

SCROLL_THRESHOLD = 460

BuyButton.View = Backbone.View.extend
  el: "#purchase-cluster, .multi-option-overlay, .purchase_cluster_wrapper, #header-purchase-cluster"
  events:
    "click a.buy-button:not(.external-buy)": "buyButtonClicked"
    "click .view-options a": "viewAllOptions"
    "click .multi-option-breakout input": "updateMultiOptionBreakoutButton"
    "click .multi-option-overlay-items input": "updateMultiOptionBreakoutButton"
    "click .multi-option-overlay-cluster a div.text": "goToTips"

  initialize: ({@multiOptionEnabled, @multiOptionInline, @buyButtonEnabled, @hasVariations, @goodsCartFormEnabled}) ->
    @$buyContainer = @$(".buy")
    @$buyButton = @$("a.buy-button")
    @$giftButton = @$("a.buy-for-friend")
    @$dealHeroPrice = @$(".deal-hero-price, .multi-option-overlay-cluster-price")
    @$mainBtnPrice = @$("#main-button-formatted-price")
    @$priceBox = @$(".price, .multi-option-overlay-cluster-price")
    @$priceLabel = @$(".price-label, .multi-option-overlay-cluster-price-label")
    @$value = @$("#discount-value, .discount-value, .breakout-option-value")
    @$strikethroughPrice = @$(".value-source-wrapper, .breakout-option-value")
    @$valueSourceWrapper = @$(".value-source-wrapper")
    @$valueSourceLabel = @$(".source-metadata-label")
    @$valueSourceDescription = @$(".source-metadata-description")
    @$smallPrice = @$(".discount-value")
    @$multiOptionBreakout = @$('.multi-option-breakout, .modal-body')
    @$multiOptionOverlay = @$el.filter('.multi-option-overlay')
    @$multiOptions = @$('.multi-option-breakout input, .multi-option-overlay-item input')
    @$buyButtonLoader = @$buyButton.find('.order-processing-loader')
    @$finePrintDesc = $(".fine-print-description")
    @$headerTitles = $(".header-title-item")
    @$headerOptions = $(".header-options")
    @i18n = I18n.scoped() if I18n?
    @$discount = @$(".breakout-messages .discount-message")
    @$valueBox = @$(".multi-option-overlay-cluster-value")
    @$overlayCluster = @$(".multi-option-overlay-cluster")
    @$soldBox = @$overlayCluster.find("div.sold-message")
    @$discountBox = @$overlayCluster.find("div.discount-message")
    @$expirationBox = @$overlayCluster.find("div.expiration")
    @$overlayList = @$('.multi-option-overlay-list')
    @$overlayFade = @$('.scroll-fade-overlay')
    @$shippingFee = @$('.shipping-value')
    @$shippingFeeOverlay = @$('.shipping-value-overlay')
    @$purchaseCreditsMessagingPlaceHolder = @$('.purchase-credits-messaging.placeholder')
    @$goodsWarrantyOption = @$('.goods-warranty-option')

    if @$purchaseCreditsMessagingPlaceHolder.length
      @fetchAndDisplayPurchaseCreditsMessage().send()

    if @hasVariations
      @$priceBox = @$(".price, .multi-option-overlay-cluster-price, .breakout-option-price")
      @$urgencyPricingMessage = @$multiOptionBreakout.find('.urgency-pricing-label')
      @$soldMessage = @$multiOptionBreakout.find('.sold-message')

    if @$multiOptionOverlay.length
      @$discountPercent = @$('#discount-percent, .discount-percent')
      @$discountYouSave = @$('#discount-you-save, .discount-you-save')
      @$qtyBought = @$('.qty-bought')
      @$dealStatus = @$('.deal-status')
      @fixPossiblePriceOverflow()

    @hasBeenClicked = false
    @variationsSelected = false

    if @multiOptionInline
      @restoreOptionSelection()

    processLink = =>
      @processLink()

    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000)

    window.DealEventPipe.on "priceUpdate", (priceData) =>
      @variationsSelected = priceData.variationsSelected
      @$buyButton.removeClass("login-disabled")
      @updatePrice priceData
      @updateShippingCharge priceData
      @updateValue priceData
      @updateMSRP priceData
      @updateDiscount priceData
      @updateSoldMessage priceData
      @updateBuyButton priceData
      @updateAffirmPrice priceData

    @$overlayList.on 'scroll', =>
      @handleFadeout()

  handleFadeout: ->
    if @$overlayList[0].scrollHeight <= SCROLL_THRESHOLD
      return
    if @$overlayList.scrollTop() + @$overlayList.innerHeight() >= @$overlayList[0].scrollHeight
      if @$overlayFade.is(':visible')
        @$overlayFade.hide()
    else if !@$overlayFade.is(':visible')
      @$overlayFade.show()

  buyButtonClicked: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'buy_button_clicked', e

  shouldShowPriceInTwoRows: ->
    includeMargin = true
    @$priceBox.outerWidth(includeMargin) + @$smallPrice.outerWidth(includeMargin) > @$dealHeroPrice.outerWidth(includeMargin)

  setPriceWithSale: (newPrice) ->
    @$priceBox.text newPrice
    @fixPossiblePriceOverflow()

  setOfferLabel: (offerLabel) ->
    return unless offerLabel?.length

    if @hasVariations
      @$urgencyPricingMessage.text offerLabel
      @$soldMessage.hide()
      @$priceBox.addClass 'urgency-pricing'
    else
      offerLabel = "<span class='urgency-pricing-label'>#{offerLabel}</span>"
      @$dealHeroPrice.append offerLabel
      @$dealHeroPrice.addClass 'urgency-pricing'

  cleanPriceBox: ->
    if @hasVariations
      @$urgencyPricingMessage.text('')
      @$soldMessage.text('').show()
      @$priceBox.removeClass 'urgency-pricing'
    else
      @$priceBox.removeClass 'two-rows'
      @$priceBox.find('.urgency-pricing-label').remove()
      @$dealHeroPrice.removeClass 'urgency-pricing'

  setPriceBox: (price, sale, variationsSelected) ->
    @cleanPriceBox()
    if sale?.urgencyPricing?
      @setPriceWithSale sale.urgencyPricing.newPrice
      @setOfferLabel sale.urgencyPricing.pricingMetadata?.offerLabel, variationsSelected
    else if sale?.offer?
      @$mainBtnPrice.text sale.offer.formattedNewPrice
      @setPriceWithSale sale.offer.formattedOldPrice
    else
      @$priceBox.text price

  updatePrice: ({ lengthClass, price, sale, variationsSelected }) ->
    @$buyContainer.removeClass @currentPriceClass if @currentPriceClass
    @$buyContainer.addClass lengthClass if lengthClass
    @setPriceBox price, sale, variationsSelected
    @currentPriceClass = lengthClass
    if variationsSelected or @$strikethroughPrice?.length
      @$priceLabel.hide()
      @$valueSourceWrapper.show()
      @$valueSourceWrapper.css("display", "flex")
      @$value.show()
    else
      @$priceLabel.show()
      @$valueSourceWrapper.hide()
      @$value.hide()

  updateShippingCharge: (priceData) ->
    @$shippingFee.text(priceData.shippingValue)

  updateClusterShippingCharge: (shippingValue) ->
    @$shippingFee.text(shippingValue)
    @$shippingFeeOverlay.text(shippingValue)

  updateAffirmPrice:  ({affirmAmount}) ->
    Affirm.updateAffirmPrice(affirmAmount)

  updateValue: ({ value, hideOriginalPriceAndDiscount }) ->
    @$value.html if hideOriginalPriceAndDiscount then "" else value

  updateMSRP: ({ valueSourceMetadata, hideOriginalPriceAndDiscount }) ->
    if valueSourceMetadata?.label and valueSourceMetadata?.description and not hideOriginalPriceAndDiscount
      { label, description } = valueSourceMetadata
      @$valueSourceLabel.html label
      @$valueSourceDescription.html description
    else
      @$valueSourceLabel?.html ""
      @$valueSourceDescription?.html ""

  updateDiscount: ({ percent, hideOriginalPriceAndDiscount, showDifferenceMessage }) ->
    unless hideOriginalPriceAndDiscount
      if showDifferenceMessage
        discountHtml = @i18n.t 'js.modules.buy_button.multi_option.difference_percentage', rawDiscountPercentage: percent
      else
        discountHtml = @i18n.t 'js.modules.buy_button.multi_option.discount_percentage', rawDiscountPercentage: percent

    @$discount.html(discountHtml ?= "")

  updateSoldMessage: ({ variationsSelected, soldMessage }) ->
    @$soldMessage.text(soldMessage) if variationsSelected

  updateBuyButton: (option) ->
    { variationsSelected, buyUrl, dealUuid, uuid } = option

    if variationsSelected
      if @goodsCartFormEnabled
        @updateGoodsCartForm(dealUuid, uuid)
      else
        buyUrl = localSupplyUrl if localSupplyUrl = @getLocalSupplyUrl(option)
        @$buyButton.attr("href", buyUrl)
        @$giftButton.attr("href", addGiftingToUrl(buyUrl))

  updateGoodsCartForm: (dealUuid, optionUuid) ->
    window.DealEventPipe.trigger('cartFormInitialize', {dealUuid, uuid: optionUuid})

  getLocalSupplyUrl: ({ buyUrl }) ->
    return unless shippingOptionData = GoodsLocalSupply?.View?.getSelectedShippingOptionData()
    getBuyUrlWithShippingOptionData buyUrl, shippingOptionData

  disableBuyButton: ->
    @hasBeenClicked = true
    @$buyButton.removeClass("state-buy")
    @$buyButton.addClass("state-disabled")
    @$headerOptions.fadeOut()
    @$buyButtonLoader.show()

  enableBuyButton: ->
    @hasBeenClicked = false
    @$buyButton.removeClass("state-disabled")
    @$buyButton.addClass("state-buy")
    @$headerOptions.fadeIn()
    @$buyButtonLoader.hide()

  processLink: ->
    return unless @buyButtonEnabled
    unless @hasBeenClicked
      if @goodsCartFormEnabled and not @$goodsWarrantyOption.is(':checked')
        window.DealEventPipe.trigger('cartFormSubmit')
      else
        newUrl = @$buyButton.attr("href")

        window.location = newUrl

    @disableBuyButton()

  updateMultiOptionBreakoutButton: (e) ->
    $option = @$multiOptions.filter(e.currentTarget)
    return if !$option.length or $option.hasClass('selected') or !@buyButtonEnabled

    @$multiOptions.removeClass 'selected'
    $option.addClass 'selected'

    value = $option.val()
    {deal, option, uuid} = $option.data()
    optionInfo = { buyUrl: value, dealUuid: deal, id: option, uuid }
    value = localSupplyUrl if localSupplyUrl = @getLocalSupplyUrl optionInfo

    if @goodsCartFormEnabled
      @updateGoodsCartForm(deal, uuid)
    else
      @$buyButton.attr 'href', value
      @$giftButton.attr 'href', addGiftingToUrl(value)

    if @$multiOptionOverlay.length
      @updateClusterOptionPrice($option)
      @syncDealOptions($option)
      @cleanPriceBox()
      @setOfferLabel $option.attr('data-offer-label')
      @fixPossiblePriceOverflow()
      @updateClusterShippingCharge $option.attr('data-shipping-value')
    else
      @updateHeaderPrice($option)
      @updateShippingCharge $option.attr('data-shipping-value')

    @updateHeaderTitle($option)

    BuyButton.eventBus.go('buy_button_clicked', e) if $option.parent('a').length
    window.DealEventPipe.trigger 'goodsOptionUpdate', optionInfo if payload.goodsWarranty or payload.productBundles

  updateHeaderPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)

  updateHeaderTitle: ($option) ->
    breakoutOptionID = @getPurchaseClusterOptionId($option.attr('id'))
    @$headerTitles.removeClass 'checked'
    targetTitleId = "#header-title-#{breakoutOptionID}"
    selectedTitle = @$headerTitles.filter(targetTitleId)
    selectedTitle.addClass 'checked'

  updateClusterOptionPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    offerLabel = $option.attr('data-offer-label') or ''
    soldMessage = $option.attr('data-sold-message') or ''
    breakoutOptionID = @getPurchaseClusterOptionId($option.attr('id'))
    finePrintDesc = $option.attr('data-description') or ''

    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)
    @$valueBox.text(formattedValue)
    @$soldBox.text(soldMessage)
    @fixPossiblePriceOverflow()

    # optional elements may or may not exist
    @updateClusterOptionDiscount($option)
    @updateExpiration($option)
    @$priceBox.find('.urgency-pricing-label').text(offerLabel)
    @updateUrgencyPricingMetaData(offerLabel, breakoutOptionID)

    if soldMessage.length
      @$qtyBought.text(soldMessage)
      @$dealStatus.show()
    else
      @$dealStatus.hide()

    @updateFinePrint(finePrintDesc)

  updateExpiration: ($option) ->
    expiration = $option.attr('data-expiration') or ''
    @$expirationBox.text(expiration)

  updateClusterOptionDiscount: ($option) ->
    discountPercentage = $option.attr('data-discount-percentage') or ''
    savings = $option.attr('data-savings') or ''
    if discountPercentage
      @$discountPercent.text(discountPercentage)
      @$discountYouSave.text(savings)
      $('.deal-discount').show()
    else
      $('.deal-discount').hide()
    @$discountBox.text(discountPercentage)

  updateUrgencyPricingMetaData: (offerLabel, breakoutOptionID) ->
    if offerLabel
      @$dealHeroPrice.addClass('urgency-pricing tooltip-trigger')
        .attr('data-bhw', 'UrgencyPrice')
        .attr('data-tooltip-id', "urgency-pricing-tooltip-#{ breakoutOptionID }")
        .attr('data-position', "left")
    else
      @$dealHeroPrice.addClass('c-txt-price')
      @$dealHeroPrice.removeClass('urgency-pricing tooltip-trigger')
        .removeAttr('data-bhw')
        .removeAttr('data-tooltip-id')
        .removeAttr('data-position')

  fixPossiblePriceOverflow: ->
    @$priceBox.removeClass('two-rows')
    @$smallPrice.removeClass('two-rows')
    if @shouldShowPriceInTwoRows()
      @$priceBox.addClass('two-rows')
      @$smallPrice.addClass('two-rows')

  viewAllOptions: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'view_options_clicked', e
    if @$overlayList[0]?.scrollHeight <= SCROLL_THRESHOLD
      @$overlayFade.hide()

  restoreOptionSelection: () ->
    @$el.find('.multi-option-breakout li input:first').trigger 'click'

  syncDealOptions: ($option) ->
    optionId = $option.attr('id')

    if optionId.indexOf('overlay') != -1
      breakoutOptionId = "##{@getPurchaseClusterOptionId(optionId)}"
      @reorderDealOptions(breakoutOptionId)
    else
      breakoutOptionId = "#overlay-#{optionId}"

    $(breakoutOptionId).prop('checked', true)

  getPurchaseClusterOptionId: (optionId) ->
    return '' unless optionId?

    return optionId.replace('overlay-', '')

  reorderDealOptions: (breakoutOptionId) ->
    $optionElem = $(breakoutOptionId).parents('li')

    return if $optionElem.is(':visible')

    $optionElem.insertBefore($optionElem.siblings('li').first())
    $optionElem.parent().find('li:visible:last').hide()
    $optionElem.show()

  updateFinePrint: (finePrintDesc) ->
    return unless finePrintDesc?.length
    $body = $(document.body)

    if $body.hasClass('getaways') or $body.hasClass('getaways-booking')
      finePrintLines = if I18n?.country is "US"
        tempLines = _.filter finePrintDesc.split(". "), (line) ->
          line.replace(/<[^>]*>/g, '').trim().length > 0

        tempLines = _.map tempLines, (line) -> "<li class='fine-print-description'>#{line}</li>"
        tempLines.join ''

      else
        "<span class='fine-print-description'>#{finePrintDesc.replace(/\n/g, '<br/>')}</span>"

      $(finePrintLines).insertBefore(@$finePrintDesc.first())
      @$finePrintDesc.remove()
      @$finePrintDesc = @$('.fine-print-description')

    else
      @$finePrintDesc.html finePrintDesc

  goToTips: (e) ->
    e.preventDefault()
    GIG.Modal.close()
    window.location.href = "#tips"

  handleAjaxResponse: (res) ->
    if res && res.amount
      amount = "<span class='c-txt-price' data-bhc='numBucks:#{res.amount}'>$#{res.amount}</span>"

      purchaseCreditsMessage = @i18n.t 'js.modules.buy_button.purchase_credits_messaging', {amount}
      @$purchaseCreditsMessagingPlaceHolder.attr('data-bhw', 'BucksDealPageDisplay')
      @$purchaseCreditsMessagingPlaceHolder.html("<span class='icon-bucks c-txt-price'></span><div>#{purchaseCreditsMessage}</div>")
      @$purchaseCreditsMessagingPlaceHolder.removeClass('placeholder')
    else
      @$purchaseCreditsMessagingPlaceHolder.remove()

  fetchAndDisplayPurchaseCreditsMessage: ->
    new FetchHandler(
      url: '/deals/user_proxy/available_credits',
      requestOpts: {credentials: 'same-origin'},
      successHandlers: [@handleAjaxResponse.bind(this)]
    )


module.exports = BuyButton.View
